/**
 * check if the user is currently using an RTL lang
 * @param lang the (2-character) language code to check against
 * @returns boolean
 * @todo could add these sep as a var in lang defs, but would require another import, so maybe not worth unless JUST the langs are needed elsewhere
 */
export const isRTL = (lang: string): boolean => {
  return ["ar", "fa", "iw", "ur", "ps", "sd", "yi"].includes(lang);
};
